import auth from './auth'

import others from './others'
import barcodes from './barcodes'
import panels from './panels'
import ProjectsApi from './projects'

import library from './library'

import runs from './runs'
import experiments from './experiments'
import explibs from './explibs'

import session from './session'


const api = {
	auth: auth,

	// справочники всякие разные
	others: others,
	barcodes: barcodes,
	panels: panels,
	projects: new ProjectsApi(session),
	library: library,

	runs: runs, // планируемые запуски
	experiments: experiments, // чипы/ячейки
	explibs: explibs, // всё, что связано с созданием и обновлением runlib
}

export default api